import { _t } from "core/language";
import { memo } from "react";
import IconSectionSuggestion from "../icon/IconSectionSuggestion";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { RouterName } from "core/router";

const CommunityHeader = () => {
  const navigate = useCustomNavigate();
  const goToList = () => {
    navigate(RouterName.COMMUNITY_LIST);
  };
  return (
    <div className="pl-4 mb-1">
      <div className="flex items-center justify-between">
        <p className="z-10 text-[#777777] text-xs font-normal mb-[2px]">
          {_t("main.community.sub_title")}
        </p>
        <span
          className="z-10 text-[#333333] text-xs font-normal mb-[2px] mx-2"
          onClick={goToList}
        >
          {_t("main.community.discover")}
        </span>
      </div>
      <h1 className="text-[17px] font-bold text-[#111111] flex items-center">
        <div className="mr-1">
          <IconSectionSuggestion />
        </div>{" "}
        {_t("main.community.title")}
      </h1>
    </div>
  );
};

export default memo(CommunityHeader);
